const cashierBarOptions = function customBarOptions() {
  return {
    title: {
      show: true,
      textStyle: {
        color: "#888",
        fontSize: 16,
        fontWeight: 'normal',
      },
      text: "暂无数据",
      left: "center",
      top: "175",
    },
    color: ['#00BBFF', '#65BE3E'],
    tooltip: {
      trigger: 'axis',
      backgroundColor: "#333",
      //   textStyle: {
      //     color: "#FFAE00",
      //   },
      formatter(params) {
        let showHtm = "";
        for (let i = 0; i < params.length; i += 1) {
          if (i === 0) {
            showHtm += `<span style="color: #FE8600">营业收入:${params[i].data / 100}元</span><br>`;
          } else {
            showHtm += `<span style="color: #FE8600">收款笔数:${params[i].data}笔</span>`;
          }
        }
        return showHtm;
      },
      padding: [15, 30],
      axisPointer: { // 坐标轴指示器，坐标轴触发有效
        type: 'none', // 默认为直线，可选为：'line' | 'shadow'
      },
      extraCssText: 'box-shadow:0px 6px 13px 0px rgba(65,140,231,0.18);text-align:center;',
    },
    dataZoom: [{
      handleSize: 0,
      show: true,
      realtime: true,
      start: 0,
      end: 30,
      zoomLock: true,
      borderRadius: 5,
      filterMode: 'filter',
      height: 20,
      bottom: 20,
      showDataShadow: false,
      showDetail: false,
      borderColor: "rgba(132,205,149,0.2)",
      fillerColor: 'rgba(233, 233, 233, 1)',
      minValueSpan: 1,

    }, {
      type: 'inside',
    },
    ],
    legend: {
      data: ["营业收入", "收款笔数"],
      right: '80px',
    },
    grid: {
      left: '1%',
      right: '4%',
      bottom: '6%',
      top: "7%",
      containLabel: true,
    },
    xAxis: {
      show: true,
      type: 'category',
      offset: 15,
      data: [],
      axisTick: {
        alignWithLabel: true,
      },
      axisLabel: { interval: 0 },
    },
    yAxis: [{
      type: 'value',
      scale: false,
      minInterval: 0.01,
      splitLine: { show: false },
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        formatter(value) {
          if (value === 0) {
            return `${value / 100}元`;
          }
          return value / 100;
        },
      },
    },
    {
      type: 'value',
      scale: false,
      minInterval: 1,
      splitLine: {
        show: true,
      },
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        formatter(value) {
          if (value === 0) {
            return `${value}笔`;
          }
          return value;
        },
      },
    }],
    series: [
      {
        type: 'bar',
        name: '营业收入',
        barWidth: '15px',
        yAxisIndex: 0,
        itemStyle: {
          emphasis: { color: '#58D2FF' }, // 鼠标滑过柱子颜色变化
          barBorderRadius: [3, 3, 0, 0],
        },
        data: [],
      },
      {
        type: 'bar',
        name: '收款笔数',
        barWidth: '15px',
        yAxisIndex: 1,
        itemStyle: {
          emphasis: { color: '#7EC85D' }, // 鼠标滑过柱子颜色变化
          barBorderRadius: [3, 3, 0, 0],
        },
        data: [],
      },
    ],
  };
};

export default cashierBarOptions;
